module.exports = __webpack_public_path__ + "img/icon_customer_blue.d5b6ea8e.svg";